import type { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { UserListModal } from '@/components/UserListModal';
import { useUserBrowserTools } from '@/hooks/api/useShadowAiTools';

import { COLUMNS, type ShadowAiUserBrowserTool } from './constants';

interface UserInfo {
  id: string;
  user: string;
  installedCount: number;
  browserCount: number;
  addedAt: string | null;
  extras?: Record<string, string>;
}

interface UserBrowserAIToolsModalProps {
  open: boolean;
  onClose: () => void;
  user: UserInfo | null;
}

export function UserBrowserAIToolsModal({
  open,
  onClose,
  user,
}: UserBrowserAIToolsModalProps): ReactElement | null {
  const { organizationId } = useParams<{ organizationId: string }>();
  const query = useUserBrowserTools(organizationId, user?.id ?? null, open);

  if (!user) {
    return null;
  }

  return (
    <UserListModal<ShadowAiUserBrowserTool>
      contentClassName="w-[700px]"
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) {
          onClose();
        }
      }}
      title={
        <>
          Browser AI tools used by{' '}
          <span className="font-mono">{user.user}</span>
        </>
      }
      query={query}
      columns={COLUMNS}
      emptyState="No browser AI tools found for this user"
    />
  );
}
